import React from 'react'
import styled from 'styled-components/macro'
import { Spinner } from 'src/Throbber/Spinner'
import { FlexAlign } from '../Flex'
import { FlexColumn } from '../Flex'

const FullPageSpinnerContainer = styled(FlexColumn)`
  height: 100vh;
`

export const FullPageSpinner = (): JSX.Element => {
  return (
    <FullPageSpinnerContainer
      justify={FlexAlign.CENTER}
      align={FlexAlign.CENTER}
    >
      <Spinner size="l" color="primary" />
    </FullPageSpinnerContainer>
  )
}
